import { faX } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Grid, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import HeaderPortal from "./HeaderPortal";
import EmployeeHeader from "../../containers/EmployeeData/EmployeeHeader/EmployeeHeader";
import EmployeePersonalAndChangingDocuments from "../../containers/EmployeeData/EmployeePersonalAndChangingDocuments";
import LoadingOverlay from "../../containers/LoadingOverlay/LoadingOverlay";

import useAbortableLoadResponse from "../../custom-hooks/useAbortableLoadResponse/useAbortableLoadResponse";
import { EmployeeDTO } from "../../models/employees/employee-dto";
import { EmployeesApiService } from "../../services/employees/employees-api.service";

import { ParamState } from "../my-team-documents/MyTeamDocumentsTable/interfaces";

const EmployeeDocuments = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();

  const params = useLocation();
  const paramState = params?.state as ParamState;
  const isReadOnly = !!paramState?.readOnly;

  const [employee, setEmployee] = useState<EmployeeDTO | null>(null);

  const { response, loading, error } = useAbortableLoadResponse<EmployeeDTO>(EmployeesApiService, {
    propsFilter: { ids: [id] },
  });

  useEffect(() => {
    if (response?.items) setEmployee(response?.items[0] ?? null);
  }, [response?.items]);

  return (
    <LoadingOverlay
      loading={loading}
      error={error}
    >
      <HeaderPortal title={`${t("components.data_and_documents.title")}`} />
      <Grid
        style={{
          width: "100",
          display: "flex",
          justifyContent: "space-between",
          padding: "10px 0px",
          position: "sticky",
          backgroundColor: theme.palette.background.default,
          zIndex: 10,
          top: 0,
        }}
      >
        <EmployeeHeader
          employee={response?.items[0] ?? null}
          buttonToRender={
            <>
              {!isReadOnly && (
                <Link to={`/employees/employee-data/${response?.items[0].id}`}>
                  <Button
                    size={"small"}
                    variant={"contained"}
                    style={{
                      fontSize: "12px",
                      textTransform: "none",
                      padding: "3px",
                    }}
                  >
                    View Employee data
                  </Button>
                </Link>
              )}
            </>
          }
        />
        <Button
          className="close"
          onClick={() => navigate(-1)}
        >
          <FontAwesomeIcon
            icon={faX}
            style={{ color: theme.palette.error.main }}
          />
        </Button>
      </Grid>
      {employee ? (
        <EmployeePersonalAndChangingDocuments
          employee={employee}
          forManager={true}
          isReadOnly={isReadOnly}
        />
      ) : (
        <Typography>Please select an employee</Typography>
      )}
    </LoadingOverlay>
  );
};

export default EmployeeDocuments;
